import script from "./ParticipantEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantEditor.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantEditor.vue?vue&type=style&index=0&id=0f29d88f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f29d88f"]])

export default __exports__